module.exports = __webpack_public_path__ + "static/img/yumi.92c55995.png";